var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useCallback } from 'react';
import { useMutation } from '@apollo/client';
import { HIGHLIGHT_IN_DOCUMENT_MUTATION } from './mutation';
export const useGetHighlightInDocument = () => {
    const [mut] = useMutation(HIGHLIGHT_IN_DOCUMENT_MUTATION, {
        context: { important: true },
    });
    return {
        getHighlightInDocument: useCallback((query, texts) => __awaiter(void 0, void 0, void 0, function* () {
            var _a;
            try {
                const { data } = yield mut({
                    variables: {
                        query,
                        texts,
                    },
                });
                return (_a = data === null || data === void 0 ? void 0 : data.highlightInDocument) === null || _a === void 0 ? void 0 : _a.similarities;
            }
            catch (e) {
                return [];
            }
        }), [mut]),
    };
};
